import { IconComponentFunction } from '@motorway/mw-highway-code';
import { Layout } from '@motorway/mw-highway-code/pre-alpha';

import styles from './ActionTile.module.scss';

type ActionTileProps = {
  icon: IconComponentFunction;
  text: React.ReactNode;
  title: React.ReactNode;
}

export const ActionTile = ({ icon: Icon, text, title }: ActionTileProps) => <div className={styles.actionTile}>
  <Layout prepend={<div className={styles.icon}><Icon /></div>}>
    <div className={styles.content}>
      <h4 className={styles.title}>{title}</h4>
      <p data-thc-style-override className={styles.text}>{text}</p>
    </div>
  </Layout>
</div>;
